import { DefaultTheme, defaultTheme } from "@quantum-wealth/dionysus-ui"
import merge from "lodash.merge"

/* This is the custom App theme.
  It can overwrite if needed the Components Library theme (white-labeled products). */

export const appTheme: DefaultTheme = merge(defaultTheme, {
  /* Extend the out-of-the-box Flowbite React theme:

  Overwrite on a component level here, whatever needs to be changed. (You can
  find each component's out-of-the-box styles on their respective pages,
  eg. https://www.flowbite-react.com/docs/components/alert#theme)

  Note: You can use the "design-tokens" from the main tailwind config file here */
  table: {
    head: {
      cell: {
        base: "alpheya-label-lg text-text-primary bg-background-subtle px-4 py-3",
      },
    },
  },
} as DefaultTheme)
